/* eslint-disable no-restricted-globals */
import { AUTOMATIC_TOKEN_CHECK_TIME_MS } from './App.constants';

/* this is added for manipulation with dom. (for exaple: ctx.addEventListener("message", function (event) {});) */
const ctx: Worker = self as any;

self.onmessage = (e: MessageEvent<string>) => {
  setInterval(() => {
    self.postMessage(2);
  }, AUTOMATIC_TOKEN_CHECK_TIME_MS);
};

export {};
